import React from "react";
import { Box, Text, Image } from "@chakra-ui/react";
import goldIcon from "../../../../assets/img/gold-icon.png";

interface AssetIconProps {
  symbol: string;
  size?: number;
}

const AssetIcon: React.FC<AssetIconProps> = ({ symbol, size = 32 }) => {
  // Extract the base symbol (e.g., "BTC" from "BTC/USDT" or "XAU" from "XAU/USD")
  const baseSymbol = symbol.split("/")[0];
  
  // Use gold icon for XAU/USD
  if (baseSymbol === "XAU") {
    return (
      <Box
        w={`${size}px`}
        h={`${size}px`}
        flexShrink={0}
        display="flex"
        alignItems="center"
        justifyContent="center"
        overflow="hidden"
        borderRadius="full"
        position="relative"
      >
        <Image
          src={goldIcon}
          alt="Gold icon"
          w="100%"
          h="100%"
          objectFit="cover"
          borderRadius="full"
          loading="eager"
          fallback={
            <Box
              w="100%"
              h="100%"
              bg="#F7931A"
              borderRadius="full"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Text fontSize="xs" color="white" fontWeight="bold">
                XAU
              </Text>
            </Box>
          }
        />
      </Box>
    );
  }
  
  // Simple colored box with symbol text as placeholder for other assets
  const colors: { [key: string]: string } = {
    BTC: "#F7931A",
    ETH: "#627EEA",
    SOL: "#9945FF",
    ADA: "#0033AD",
    XRP: "#23292F",
    DOT: "#E6007A",
  };

  const bgColor = colors[baseSymbol] || "#38BBD1";

  return (
    <Box
      w={`${size}px`}
      h={`${size}px`}
      bg={bgColor}
      borderRadius="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
    >
      <Text
        fontSize={`${size * 0.4}px`}
        fontWeight="bold"
        color="white"
        textTransform="uppercase"
      >
        {baseSymbol[0]}
      </Text>
    </Box>
  );
};

export default AssetIcon;
